export const Tabs = () => {
    return (
        <section id="tabs">
            <h2>Empower everyone, on every team</h2>
            <hr />
        </section>
    );
};
